import React, { useRef, useState } from "react";
import { useMount, useUpdateEffect } from "ahooks";
import { Select, Radio, message } from "antd";
import AppSetting from "../../../config/AppSetting";
import {
  downloadFileByUrl,
  getDate,
  getTimeZoneString,
  userRoles,
} from "../../publicDictionaryValues";
import NormalSpin from "../../../base/basicComponents/spin";
import TopFilter from "./toDoListSections/topFilter/index";
import SearchAndColumnSelect from "../procedureList/procedureListSections/searchAndColumnSelect";
import ToDoListConlumnSelectOption, {
  ToDoListColumnSelectValue,
} from "./toDoListSections/conlumnSelectOption";
import ListTable from "../../commonComponents/listTable/index";
import ToDoListColumn from "./toDoListSections/toDoListColumn";
import ToDoListTableFilterMap from "../../commonComponents/listTable/toDoListFilterMap";
import FooterPagination from "../procedureList/procedureListSections/footerPagination";
import toDoListService from "../../../service/toDoListService/index";
import styles from "../procedureList/index.module.scss";
import toDoListStyles from "./index.module.scss";
import "./index.scss";
import { poll } from "../../commonComponents/polling/polling";
import { useBatchDelegate } from "app/pages/procedureList/procedureListSections/searchAndColumnSelect/batchDelegateButton";
import { createFakeProgressGenerator } from "app/pages/procedureList/utils";
import classNames from "classnames";

const getFakeProgress = createFakeProgressGenerator(98, 0.05);
let timer: any = null;
export default function ToDoList() {
  const searchAndColumnSelectRef = useRef(null);
  const selectRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const [taskLabelName, setTaskLabelName] = useState("");
  const [taskId, setTaskId] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [currentTaskLabelName, setCurrentTaskLabelName] = useState("");
  const [currentTaskId, setCurrentTaskId] = useState("");
  const [currentTransactionId, setCurrentTransactionId] = useState("");
  const [currentPage, setCurrentPage] = useState({
    pageNumber: 1,
    pageSize: 30,
  });
  const [totalPage, setTotalPage] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [toDoListData, setToDoListData] = useState([]);

  const [topFiterData, setTopFiterData] = useState([]);
  const [tableFilterData, setTableFilterData] = useState([]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [tableSortData, setTableSortData] = useState([]);
  const [toDoListFilterData, setToDoListFilterData] = useState({});
  const [tableColumnFilterParam, setTableColumnFilterParam] = useState(null);

  const [transactionIdShow, setTransactionIdShow] = useState(true);
  const [delegateToOthersShow, setDelegateToOthersShow] = useState(true);
  const [actionCompletedDateShow, setActionCompletedDateShow] = useState(true);
  const [processCategoryShow, setProcessCategoryShow] = useState(true);
  const [actionRequiredShow, setActionRequiredShow] = useState(true);
  const [revisionDescriptionShow, setRevisionDescriptionShow] = useState(true);
  const [actionTakenShow, setActionTakenShow] = useState(true);
  const [delegatedByShow, setDelegatedByShow] = useState(true);
  const [delegatedToShow, setDelegatedToShow] = useState(true);
  const [dueDateShow, setDueDateShow] = useState(true);
  const [receiveDateShow, setReceiveDateShow] = useState(true);
  const [requestByShow, setRequestByShow] = useState(true);
  const [processInitiateDateShow, setProcessInitiateDateShow] = useState(false);
  const [processInitiatorShow, setProcessInitiatorShow] = useState(false);
  const [accountAbbrShow, setAccountAbbrShow] = useState(true);
  const [accountNameShow, setAccountNameShow] = useState(false);
  const [taskGroupShow, setTaskGroupShow] = useState(true);
  const [categoryShow, setCategoryShow] = useState(true);
  const [taskIdShow, setTaskIdShow] = useState(false);
  const [taskLabelNameShow, setTaskLabelNameShow] = useState(true);
  const [highlyRegulatedShow, setHighlyRegulatedShow] = useState(false);

  const [toDoListDivHeight, setToDoListDivHeight] = useState([0]);
  const [toDoListTableBodyHeight, setToDoListTableBodyHeight] = useState([0]);
  const [progress, setProgress] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);
  const [currentSelectColumnOption, setCurrentSelectColumnOption] = useState(null);
  const {
    rowSelection,
    selectedRowKeys,
    setAllTableRows,
    clearBatchDelegateInfo,
    flushTableListDueToDelegate,
  } = useBatchDelegate();
  const lastTimePendingListParamsRef = useRef(null);

  const resetState = () => {
    setTaskLabelName((pre) => "");
    setTaskId((pre) => "");
    setTransactionId((pre) => "");
    setCurrentTaskLabelName((pre) => "");
    setCurrentTaskId((pre) => "");
    setCurrentTransactionId((pre) => "");
    setCurrentPage({
      pageNumber: 1,
      pageSize: 30,
    });
    setTotalPage((pre) => 0);
    setTotalRecord((pre) => 0);
    setToDoListData((pre) => []);
    setTopFiterData((pre) => []);
    setTableFilterData((pre) => []);
    setFilteredInfo((pre) => {
      return {};
    });
    setTableSortData((pre) => []);
    setToDoListFilterData((pre) => {
      return {};
    });
    setTransactionIdShow((pre) => true);
    setDelegateToOthersShow((pre) => true);
    setActionCompletedDateShow((pre) => true);
    setProcessCategoryShow((pre) => true);
    setActionRequiredShow((pre) => true);
    setRevisionDescriptionShow((pre) => true);
    setActionTakenShow((pre) => true);
    setDelegatedByShow((pre) => true);
    setDelegatedToShow((pre) => true);
    setDueDateShow((pre) => true);
    setReceiveDateShow((pre) => true);
    setRequestByShow((pre) => true);
    setProcessInitiateDateShow((pre) => false);
    setProcessInitiatorShow((pre) => false);
    setAccountAbbrShow((pre) => true);
    setAccountNameShow((pre) => false);
    setTaskGroupShow((pre) => true);
    setCategoryShow((pre) => true);
    setTaskIdShow((pre) => false);
    setTaskLabelNameShow((pre) => true);
    setHighlyRegulatedShow((pre) => false);
  };

  const handleUserRole = (roleModel: any) => {
    if (roleModel?.length === undefined || roleModel?.length === 0) {
      return false;
    }
    return roleModel.some((x: any) => x.roleID === userRoles.Opex);
  };

  const isOpex = handleUserRole(AppSetting.localStorageValue.role.get());

  const tabOnChange = ({ target: { value } }: any) => {
    if (exporting) return;
    setTab((pre) => value);
    resetState();
  };

  const getAccountAbbr = (accountAbbrOption: any, accountAbbrSelect: any) => {
    let filterArr = [];
    if (accountAbbrSelect.length === 0) {
      filterArr = accountAbbrOption.map((x: any) => parseInt(x.value));
    } else {
      filterArr = accountAbbrSelect.map((x: any) => parseInt(x));
    }

    return {
      filterColumn: "AccountID",
      filterValue: filterArr,
    };
  };

  const getActionRequired = (actionRequiredOption: any, actionRequiredSelect: any) => {
    let filterArr = [];
    if (actionRequiredSelect.length === 0) {
      filterArr = actionRequiredOption.map((x: any) => x.value);
    } else {
      filterArr = actionRequiredSelect.map((x: any) => x);
    }

    return {
      filterColumn: "ActionRequiredID",
      filterValue: filterArr,
    };
  };

  const getActionTaken = (actionTakenOption: any, actionTakenSelect: any) => {
    let filterArr = [];
    if (actionTakenSelect.length === 0) {
      filterArr = actionTakenOption.map((x: any) => x.value);
    } else {
      filterArr = actionTakenSelect.map((x: any) => x);
    }

    return {
      filterColumn: "ActionTakenID",
      filterValue: filterArr,
    };
  };

  const getProcessCategory = (processCategoryOption: any, processCategorySelect: any) => {
    let filterArr = [];
    if (processCategorySelect.length === 0) {
      filterArr = processCategoryOption.map((x: any) => x.value);
    } else {
      filterArr = processCategorySelect.map((x: any) => x);
    }

    return {
      filterColumn: "FlowCategoryGroupID",
      filterValue: filterArr,
    };
  };

  useUpdateEffect(() => {
    setLoading(true);
    setCurrentPage({ ...currentPage, pageNumber: 1 });
    setTableFilterData([]);
    setTableSortData([]);
    setToDoListFilterData({});
    setFilteredInfo({});
    // @ts-ignore
    getPendingListTable({
      ...lastTimePendingListParamsRef.current,
      pageSize: currentPage.pageSize,
      pageIndex: 1,
    });
  }, [flushTableListDueToDelegate]);

  const getToDoListSuccess = (result: any) => {
    setLoading(false);
    setToDoListData(result.data);
    setAllTableRows(result.data, result.roles);
    setTotalPage(result.totalPage);
    setTotalRecord(result.totalRecord);
  };

  const getToDoListError = (result: any) => {
    message.error("Failed to get To Do List.");
    setLoading(false);
    console.log(result);
  };

  const getToDoListFilterSuccess = (result: any, currentField: any) => {
    setToDoListFilterData({
      ...toDoListFilterData,
      [currentField]: result?.fields,
    });
    setLoading(false);
    setFilterLoading(false);
  };

  const getToDoListFilterError = (result: any) => {
    console.log(result);
  };

  const getTopFilterCondition = () => {
    return [
      {
        key: "accountAbbr",
        filterFunction: getAccountAbbr,
      },
      {
        key: "actionRequired",
        tabCondition: tab === 0,
        filterFunction: getActionRequired,
      },
      {
        key: "actionTaken",
        tabCondition: tab !== 0,
        filterFunction: getActionTaken,
      },
      {
        key: "processCategory",
        filterFunction: getProcessCategory,
      },
    ];
  };

  const getTopFilter = (filterOptionList: any, selectOptions: any) => {
    const topFilterArr: any[] = [];
    const topFilterOptionList = JSON.parse(JSON.stringify(filterOptionList));
    const topFilterSelectOptions = JSON.parse(JSON.stringify(selectOptions));

    const filterConditions = getTopFilterCondition();

    filterConditions.forEach(({ key, tabCondition, filterFunction }) => {
      if (
        topFilterOptionList[key] !== undefined &&
        topFilterOptionList[key].length !== 0 &&
        (tabCondition === undefined || tabCondition)
      ) {
        if (
          (isOpex || tab === 1) &&
          key === "accountAbbr" &&
          topFilterSelectOptions[key].length === 0
        ) {
          return;
        }

        if (key !== "accountAbbr" && topFilterSelectOptions[key].length === 0) {
          return;
        }

        const filteredData = filterFunction(topFilterOptionList[key], topFilterSelectOptions[key]);
        topFilterArr.push(filteredData);
      }
    });

    return topFilterArr;
  };

  const getPendingListTable = (getToDoListPara: any) => {
    lastTimePendingListParamsRef.current = getToDoListPara;
    toDoListService.getPendingList(getToDoListPara, getToDoListSuccess, getToDoListError);
  };

  const getCompletedListTable = (getToDoListPara: any) => {
    toDoListService.getCompletedList(getToDoListPara, getToDoListSuccess, getToDoListError);
  };

  const handleTopFilterClick = (filterOptionList: any, selectOptions: any) => {
    const topFilterArr = getTopFilter(filterOptionList, selectOptions);
    setLoading(true);
    // @ts-ignore
    setTopFiterData(topFilterArr);
    setTaskId("");
    setTaskLabelName("");
    setTransactionId("");
    setCurrentTaskLabelName("");
    setCurrentTaskId("");
    setCurrentTransactionId("");
    setTableFilterData([]);
    setTableSortData([]);
    setToDoListFilterData({});
    setFilteredInfo({});
    setCurrentPage({ ...currentPage, pageNumber: 1 });
    const getToDoListPara = {
      filterFields: topFilterArr,
      sortFields: [],
      transactionId: "",
      taskId: "",
      taskLabelName: "",
      pageSize: currentPage.pageSize,
      pageIndex: 1,
    };

    const getToDoListFilterPara = {
      filterFields: topFilterArr,
      transactionId: "",
      taskId: "",
      taskLabelName: "",
    };
    // @ts-ignore
    setTableColumnFilterParam({ ...getToDoListFilterPara });

    if (tab === 0) {
      getPendingListTable(getToDoListPara);
    } else {
      getCompletedListTable(getToDoListPara);
    }
  };

  const ShowSearchColumn = () => {
    let searchColumnArr = [];
    if (transactionId.trim() != "") {
      searchColumnArr.push("transactionIdShow");
    }

    if (taskId.trim() != "") {
      searchColumnArr.push("taskIdShow");
    }

    if (taskLabelName.trim() != "") {
      searchColumnArr.push("taskLabelNameShow");
    }

    // @ts-ignore
    searchAndColumnSelectRef.current.handleColumnSearchSelect(searchColumnArr);
  };

  const handleSearchClick = () => {
    const topFiter = JSON.parse(JSON.stringify(topFiterData));
    setLoading(true);
    setCurrentPage({ ...currentPage, pageNumber: 1 });
    setCurrentTaskLabelName(taskLabelName.trim());
    setCurrentTaskId(taskId.trim());
    setCurrentTransactionId(transactionId.trim());
    setTableFilterData([]);
    setTableSortData([]);
    setToDoListFilterData({});
    setFilteredInfo({});
    const getToDoListPara = {
      filterFields: topFiter,
      sortFields: [],
      transactionId: transactionId.trim(),
      taskId: taskId.trim(),
      taskLabelName: taskLabelName.trim(),
      pageSize: currentPage.pageSize,
      pageIndex: 1,
    };

    const getToDoListFilterPara = {
      filterFields: topFiterData,
      transactionId: transactionId.trim(),
      taskId: taskId.trim(),
      taskLabelName: taskLabelName.trim(),
    };
    // @ts-ignore
    setTableColumnFilterParam({ ...getToDoListFilterPara });

    if (tab === 0) {
      getPendingListTable(getToDoListPara);
    } else {
      getCompletedListTable(getToDoListPara);
    }

    ShowSearchColumn();
  };

  const handleTransactionIdChange = (e: any) => {
    setTransactionId(e.value);
  };

  const handleTaskLabelNameChange = (e: any) => {
    setTaskLabelName(e.value);
  };

  const handleTaskIdChange = (e: any) => {
    setTaskId(e.value);
  };

  const handleConlumnSelectUpdate = (key: any, value: any) => {
    const updateFunctions = {
      transactionIdShow: () => setTransactionIdShow(value),
      delegateToOthersShow: () => setDelegateToOthersShow(value),
      actionCompletedDateShow: () => setActionCompletedDateShow(value),
      processCategoryShow: () => setProcessCategoryShow(value),
      actionRequiredShow: () => setActionRequiredShow(value),
      revisionDescriptionShow: () => setRevisionDescriptionShow(value),
      actionTakenShow: () => setActionTakenShow(value),
      delegatedByShow: () => setDelegatedByShow(value),
      delegatedToShow: () => setDelegatedToShow(value),
      dueDateShow: () => setDueDateShow(value),
      receiveDateShow: () => setReceiveDateShow(value),
      requestByShow: () => setRequestByShow(value),
      processInitiateDateShow: () => setProcessInitiateDateShow(value),
      processInitiatorShow: () => setProcessInitiatorShow(value),
      accountAbbrShow: () => setAccountAbbrShow(value),
      accountNameShow: () => setAccountNameShow(value),
      taskGroupShow: () => setTaskGroupShow(value),
      categoryShow: () => setCategoryShow(value),
      taskIdShow: () => setTaskIdShow(value),
      taskLabelNameShow: () => setTaskLabelNameShow(value),
      highlyRegulatedShow: () => setHighlyRegulatedShow(value),
    };

    // @ts-ignore
    const updateFunction = updateFunctions[key];
    updateFunction && updateFunction();
  };

  const handleColumnSearchSelect = (valueArr: any) => {
    setCurrentSelectColumnOption(valueArr[0]);
    for (let value of valueArr) {
      handleConlumnSelectUpdate(value, true);
    }
  };

  const handleColumnSearchDeSelect = (value: any) => {
    handleConlumnSelectUpdate(value, false);
  };

  const concatProcedureFileFilters = (topFilter: any, tableFilter: any) => {
    const mergedArray = [...topFilter];

    for (const objB of tableFilter) {
      const filterColumnB = objB.filterColumn;
      const filterValueB = objB.filterValue;
      const existingObjIndex = mergedArray.findIndex((objA) => objA.filterColumn === filterColumnB);

      if (existingObjIndex !== -1) {
        const existingObj = mergedArray[existingObjIndex];
        const filterValueA = existingObj.filterValue;
        const intersection = filterValueA.filter((value: any) => filterValueB.includes(value));
        existingObj.filterValue = intersection.length > 0 ? intersection : [];
      } else {
        mergedArray.push(objB);
      }
    }

    return mergedArray;
  };

  const getListTableData = (tab: any, getToDoListPara: any) => {
    if (tab === 0) {
      toDoListService.getPendingList(getToDoListPara, getToDoListSuccess, getToDoListError);
    } else {
      toDoListService.getCompletedList(getToDoListPara, getToDoListSuccess, getToDoListError);
    }
  };

  const handlePageChange = (pageSize: any, pageNumber: any) => {
    const topFiter = JSON.parse(JSON.stringify(topFiterData));
    const tableFilter = JSON.parse(JSON.stringify(tableFilterData));
    const sort = JSON.parse(JSON.stringify(tableSortData));
    const filterArr = concatProcedureFileFilters(topFiter, tableFilter);
    const getToDoListPara = {
      filterFields: filterArr,
      sortFields: sort,
      taskId: currentTaskId,
      taskLabelName: currentTaskLabelName,
      transactionId: currentTransactionId,
      pageSize: pageSize === null ? currentPage.pageSize : pageSize,
      pageIndex: pageNumber === null ? currentPage.pageNumber : pageNumber,
    };

    getListTableData(tab, getToDoListPara);
  };

  const handlePageNumberChange = (pageNumber: any, pageSize: any) => {
    setLoading(true);
    // @ts-ignore
    selectRef.current.blur();
    let newPageNumber = pageSize === currentPage.pageSize ? pageNumber : 1;
    setCurrentPage({
      pageSize: pageSize,
      pageNumber: newPageNumber,
    });
    if (newPageNumber !== currentPage.pageNumber || currentPage.pageSize !== pageSize) {
      clearBatchDelegateInfo();
    }
    handlePageChange(pageSize, newPageNumber);
  };

  const handleTableFilterSort = (tableFilterPara: any, tableSortPara: any, filters: any) => {
    const topFiter = JSON.parse(JSON.stringify(topFiterData));
    const tableFilter = JSON.parse(JSON.stringify(tableFilterPara));
    const sort = JSON.parse(JSON.stringify(tableSortPara));
    const filterArr = concatProcedureFileFilters(topFiter, tableFilter);
    setLoading(true);
    setCurrentPage({ ...currentPage, pageNumber: 1 });
    setTableFilterData(tableFilter);
    setTableSortData(sort);
    setFilteredInfo(filters);
    const getToDoListPara = {
      filterFields: filterArr,
      sortFields: sort,
      transactionId: currentTransactionId,
      taskId: currentTaskId,
      taskLabelName: currentTaskLabelName,
      pageSize: currentPage.pageSize,
      pageIndex: 1,
    };

    getListTableData(tab, getToDoListPara);
  };

  const handleColumnSelectValue = (value: any) => {
    if (tab === 0) {
      return value.filter((x: any) => x !== "actionCompletedDateShow" && x !== "actionTakenShow");
    } else {
      return value.filter(
        (x: any) =>
          x !== "actionRequiredShow" && x !== "dueDateShow" && x !== "delegateToOthersShow"
      );
    }
  };

  const handleColumnSelectOption = (option: any) => {
    if (tab === 0) {
      return option.filter(
        (x: any) => x.value !== "actionCompletedDateShow" && x.value !== "actionTakenShow"
      );
    } else {
      return option.filter(
        (x: any) =>
          x.value !== "actionRequiredShow" &&
          x.value !== "dueDateShow" &&
          x.value !== "delegateToOthersShow"
      );
    }
  };

  let pollStopper: any = null;
  let exportBatchId: any = null;

  const checkCompletedToDoExportStatus = async () => {
    try {
      const para = {
        exportBatchId: exportBatchId,
      };
      const statusResponse = await toDoListService.checkCompletedToDoListExport(para);
      const fileId = statusResponse.fileId;
      const totalCount = statusResponse.totalCount;
      const finishCount = statusResponse.finishCount;
      const finishPercent = Math.floor((finishCount / totalCount) * 100);
      finishPercent > 1 && setProgress(finishPercent > 99 ? 99 : finishPercent);
      return fileId;
    } catch (statusError) {
      return null;
    }
  };

  const downloadCompletedToDoSuccessful = () => {
    setProgress(100);
    setTimeout(() => {
      setProgress(0);
      setStartAnimation(false);
      setExporting(false);
    }, 1000);
  };

  const handleCompletedToDoPollingComplete = (fileId: any) => {
    setProgress(100);
    const date = getTimeZoneString(getDate(), "MMDDYYYY");
    const fileName = "Individual Completed To Do List - " + date + ".xlsx";
    const fileList = [
      {
        fileID: fileId,
        fileName: fileName,
      },
    ];
    downloadFileByUrl(fileList, downloadCompletedToDoSuccessful);
  };

  const handleCompletedToDoPollingError = (error: any) => {
    setProgress(0);
    setStartAnimation(false);
    setExporting(false);
  };

  const startCompletedToDoPolling = () => {
    if (pollStopper) pollStopper(); // Stop any existing polling

    pollStopper = poll(
      checkCompletedToDoExportStatus,
      handleCompletedToDoPollingComplete,
      2000,
      handleCompletedToDoPollingError
    );
  };

  const handleGetCompletedExportBatchIdSuccess = (response: any) => {
    exportBatchId = response.exportBatchId;
    setStartAnimation(true);
    startCompletedToDoPolling();
    setProgress(1);
  };

  /**
   * success callback about export api
   * @param {object} response
   * @param {boolean} tab flag about pending or completed list
   */
  const handlePendingExportSuccess = (response: any) => {
    const fileId = response.fileId;
    const date = getTimeZoneString(getDate(), "MMDDYYYY");
    const fileName = "Individual Pending To Do List - " + date + ".xlsx";
    const fileList = [
      {
        fileID: fileId,
        fileName: fileName,
      },
    ];

    downloadFileByUrl(fileList, () => {
      setProgress(100);
      clearInterval(timer);
      setTimeout(() => {
        setExporting(false);
      }, 1000);
    });
  };

  /**
   * error callback about export api
   * @param {object} error
   */
  const handleExportError = (error: any) => {
    setExporting(false);
    clearInterval(timer);
    message.error("Export to do list failed!");
    console.log(error);
  };

  /**
   * function about click export button for to do list
   */
  const handleExportClick = () => {
    setExporting(true);
    setProgress(0);
    const topFiter = JSON.parse(JSON.stringify(topFiterData));
    const tableFilter = JSON.parse(JSON.stringify(tableFilterData));
    const sort = JSON.parse(JSON.stringify(tableSortData));
    const filterArr = concatProcedureFileFilters(topFiter, tableFilter);
    const exportParam = {
      filterFields: filterArr,
      sortFields: sort,
      transactionId: currentTransactionId,
      taskId: currentTaskId,
      taskLabelName: currentTaskLabelName,
      pageSize: currentPage.pageSize,
      pageIndex: currentPage.pageNumber,
      isReport: true,
    };
    if (tab === 0) {
      getFakeProgress.reset();
      timer = setInterval(() => {
        const newProgress = getFakeProgress();
        setProgress(newProgress);
      }, 500);
      toDoListService.exportPendingTodoList(
        exportParam,
        (response: any) => handlePendingExportSuccess(response),
        handleExportError
      );
      return;
    }
    toDoListService.exportCompletedTodoList(
      exportParam,
      (response: any) => handleGetCompletedExportBatchIdSuccess(response),
      handleExportError
    );
  };

  const handleColumnFilterClick = (isOpen: any, currentField: any) => {
    if (!isOpen) return;

    const filterFieldList = Object.keys(toDoListFilterData);

    if (!filterFieldList.includes(currentField)) {
      setFilterLoading(true);
      const getTodoTableFilterPara = {
        // @ts-ignore
        ...tableColumnFilterParam,
        CurrentField: currentField,
      };

      if (tab === 0) {
        toDoListService.getPendingListFilter(
          getTodoTableFilterPara,
          (result: any) => getToDoListFilterSuccess(result, currentField),
          getToDoListFilterError
        );
      } else {
        toDoListService.getCompletedListFilter(
          getTodoTableFilterPara,
          (result: any) => getToDoListFilterSuccess(result, currentField),
          getToDoListFilterError
        );
      }
    }
  };

  const handleTableWidth = (columns: any, columnSelectOption: any) => {
    // @ts-ignore
    const columnSelectList =
      searchAndColumnSelectRef.current?.state.columnSelectValue || columnSelectValue;
    let width = 0;
    columnSelectList.forEach((item: any) => {
      const columnLabel = columnSelectOption.find((column: any) => column.value === item)?.label;
      const columnWidth = columns.find((column: any) => column.title === columnLabel)?.width || 0;
      width += columnWidth;
    });
    const newSelectColumnLabel = columnSelectOption.find(
      (column: any) => column.value === currentSelectColumnOption
    )?.label;
    const newSelectColumnWidth =
      columns.find((column: any) => column.title === newSelectColumnLabel)?.width || 0;
    return width + newSelectColumnWidth;
  };

  const tabOptions = [
    { label: "Pending", value: 0 },
    { label: "Completed", value: 1 },
  ];

  const columnSelectValue = ToDoListColumnSelectValue();

  const columnSelectOption = ToDoListConlumnSelectOption();

  const columns = ToDoListColumn({
    tab,
    toDoListFilterData,
    filteredInfo,
    transactionIdShow,
    delegateToOthersShow,
    taskLabelNameShow,
    actionCompletedDateShow,
    processCategoryShow,
    actionRequiredShow,
    revisionDescriptionShow,
    delegatedByShow,
    delegatedToShow,
    actionTakenShow,
    dueDateShow,
    receiveDateShow,
    requestByShow,
    processInitiateDateShow,
    processInitiatorShow,
    accountAbbrShow,
    accountNameShow,
    taskGroupShow,
    categoryShow,
    taskIdShow,
    highlyRegulatedShow,
    tableSortData,
    toDoListData,
    handleColumnFilterClick,
    filterLoading,
  });

  const calculateToDoListHeight = () => {
    const screenHeight = window.innerHeight;
    const desiredHeight = screenHeight - 114 + 8 + 10;
    // @ts-ignore
    setToDoListDivHeight(desiredHeight);
    var toDoListTopFilterDiv = document.getElementById("toDoListTopFilter");
    // @ts-ignore
    var toDoListTopFilterDivHeight = toDoListTopFilterDiv.offsetHeight;
    const tableContainer = document.querySelector(".ant-table-body");

    if (tableContainer) {
      const toDoListTableBodyHeight = desiredHeight - toDoListTopFilterDivHeight - 191 + 8;
      // @ts-ignore
      setToDoListTableBodyHeight(toDoListTableBodyHeight);
      // @ts-ignore
      tableContainer.style.height = `${toDoListTableBodyHeight}px`;
    }
  };

  useMount(() => {
    setLoading(true);
    calculateToDoListHeight();
    window.addEventListener("resize", calculateToDoListHeight);

    return () => {
      window.removeEventListener("resize", calculateToDoListHeight);
    };
  });

  return (
    <NormalSpin
      spinning={loading}
      size="large"
      children={
        // @ts-ignore
        <div className={styles.procedureListDiv} style={{ height: toDoListDivHeight }}>
          <div className={styles.procedureTopFilter} id="toDoListTopFilter">
            <div
              className={classNames(`${toDoListStyles.tabDiv} tabDiv`, {
                isExporting: exporting,
              })}
            >
              <Radio.Group
                onChange={tabOnChange}
                value={tab}
                optionType="button"
                data-testid="todo-tab-group"
              >
                <Radio.Button value={0} data-testid="pending-tab">
                  Pending
                </Radio.Button>
                <Radio.Button value={1} data-testid="completed-tab">
                  Completed
                </Radio.Button>
              </Radio.Group>
            </div>
            <TopFilter
              tab={tab}
              handleFilterClick={handleTopFilterClick}
              isOpex={isOpex}
              setLoading={setLoading}
            />
            <SearchAndColumnSelect
              ref={searchAndColumnSelectRef}
              tab={tab}
              columnSelectValue={handleColumnSelectValue(columnSelectValue)}
              columnSelectOption={handleColumnSelectOption(columnSelectOption)}
              handleSearch={handleSearchClick}
              handleExport={handleExportClick}
              taskLabelName={taskLabelName}
              taskId={taskId}
              transactionId={transactionId}
              handleTransactionIdChange={handleTransactionIdChange}
              handleTaskLabelNameChange={handleTaskLabelNameChange}
              handleTaskIdChange={handleTaskIdChange}
              handleColumnSearchSelect={handleColumnSearchSelect}
              handleColumnSearchDeSelect={handleColumnSearchDeSelect}
              showExport={true}
              exportDisabled={exporting}
              progress={progress}
              startAnimation={startAnimation}
            />
          </div>
          <div className={styles.tableDiv}>
            <ListTable
              data={toDoListData}
              columns={columns}
              rowKey="procedureStepId"
              handleFilterSort={handleTableFilterSort}
              tableFilterMap={ToDoListTableFilterMap}
              tableWidth={handleTableWidth(columns, columnSelectOption)}
              tableHeight={toDoListTableBodyHeight}
              rowSelection={tab === 0 && { ...rowSelection, selectedRowKeys }}
              className={toDoListStyles.todoListTableContainer}
              testid="todo-list-table"
              rowTestId={(record: any) => `todo-row-${record.taskId ?? record.id}`}
            />
            <div className={styles.procedurelistFooter}>
              <FooterPagination
                totalRecord={totalRecord}
                totalPage={totalPage}
                currentPage={currentPage}
                handlePageNumberChange={handlePageNumberChange}
                paginationTestId="todo-list-pagination"
                selectComponentClass={(props: any) => {
                  const options = props.children.map((item: any) => {
                    return {
                      label: item.props.children,
                      value: item.props.value,
                    };
                  });
                  return (
                    <Select {...props} options={options} optionLabelProp="label" ref={selectRef} />
                  );
                }}
              />
            </div>
          </div>
        </div>
      }
    />
  );
}
